module.exports = __webpack_public_path__ + "img/close-alt.b9c2640a.svg";